import focusTrap from './focus-trap';
import { show as showOverlay, hide as hideOverlay, create as createOverlay } from './overlay';

class Dropdown {
  constructor(element, key = '', enableBodyLock = true, preventLinksWhileOpen = false) {
    if (typeof element === 'string' || element instanceof String) {
      this.container = document.querySelector(element);
    } else {
      this.container = element;
    }

    this.classes = {
      active: 'dropdown--open',
      activeParent: 'active',
    };

    this.key = key;
    this.enableBodyLock = enableBodyLock;
    this.preventLinksWhileOpen = preventLinksWhileOpen;

    this.focusTrap = focusTrap(this.container);

    // rebind 'this' to methods
    this.clickEvent = this.clickEvent.bind(this);
    this.keydownEvent = this.keydownEvent.bind(this);
    this.addListeners = this.addListeners.bind(this);
    this.removeListeners = this.removeListeners.bind(this);

    createOverlay();
  }

  addListeners() {
    document.addEventListener('click', this.clickEvent);
    document.addEventListener('keydown', this.keydownEvent);
  }

  removeListeners() {
    document.removeEventListener('click', this.clickEvent);
    document.removeEventListener('click', this.keydownEvent);
  }

  close() {
    this.container.parentElement.classList.remove(this.classes.activeParent);
    this.container.classList.remove(this.classes.active);
    this.focusTrap.disable();
    hideOverlay();
    if (this.enableBodyLock) document.documentElement.style.overflow = 'initial';
    this.removeListeners();

    const event = new CustomEvent(`dropdown:closed:${this.key}`, {});
    document.dispatchEvent(event);
  }

  open() {
    this.container.parentElement.classList.add(this.classes.activeParent);
    this.container.classList.add(this.classes.active);
    this.focusTrap.enable();
    showOverlay();
    if (this.enableBodyLock) document.documentElement.style.overflow = 'hidden';

    setTimeout(this.addListeners, 1);
  }

  toggle() {
    if (this.container.classList.contains(this.classes.active)) {
      this.close();
    } else {
      this.open();
    }
  }

  clickEvent(e) {
    if (this.preventLinksWhileOpen) {
      e.preventDefault();
    }

    if (!this.container.contains(e.target)) {
      e.stopPropagation();
      this.close();
    }
  }

  keydownEvent(e) {
    if (e.key === 'Escape') {
      this.close();
    }
  }
}

// eslint-disable-next-line
export default (element, key, enableBodyLock, preventLinksWhileOpen) => new Dropdown(element, key, enableBodyLock, preventLinksWhileOpen);
